import { render } from "./App.vue?vue&type=template&id=8ebc7e6e&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./css/component.scss?vue&type=style&index=0&lang=scss&external"
import "./App.vue?vue&type=style&index=1&id=8ebc7e6e&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__